import { render, staticRenderFns } from "./ChoiceItem.vue?vue&type=template&id=30ea0fae"
import script from "./ChoiceItem.vue?vue&type=script&lang=js"
export * from "./ChoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports